<template>
  <a-modal
    :title="title"
    :visible="hidden"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="cancel"
    @ok="ok"
    width="500px"
    :closable="false"
    :maskClosable="false"
  >
    <div slot="footer">
      <a-button type="primary" @click="ok">确定</a-button>
    </div>
    <a-form :form="form" style="display: none;">
      <a-form-item label="动物类型名称">
        <a-input v-decorator="['animalTypeName']"/>
      </a-form-item>
      <a-form-item label="动物类型代码">
        <a-input v-decorator="['animalTypeCode']"/>
      </a-form-item>
      <a-form-item label="动物类型根id">
        <a-input v-decorator="['animalRootId']"/>
      </a-form-item>
    </a-form>
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" >
      <a-form-item label="历史动物类型" style="margin-bottom: 0;">
        {{detail.animalTypeName}}
      </a-form-item>
      <a-form-item label="历史配方模型" style="margin-bottom: 0;">
        {{detail.formulaModelName}}
      </a-form-item>
      <a-form-item label="设置动物类型">
        <a-cascader 
          :options="animal"
          :load-data="loadAnimalData"
          @change="animalChange"
          size="small"
          placeholder="请选择动物类型"
          v-decorator="['animal', { rules: [{ required: true, message: '请选择动物类型' }] }]"
        />
      </a-form-item>
      <a-form-model-item label="设置配方模型"  prop="modelId">
        <a-select
          placeholder="选择配方模型"
          :allowClear="true"
          v-decorator="['modelId', { rules: [{ required: true, message: '请选择配方模型' }] }]"
          show-search
          :filter-option="filterOption"
        >
          <a-select-option v-for="(item,index) in model.records" :key="index" :title="item.name" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form>
  </a-modal>
</template>

<script>
import { nhfMixins } from "../../untils";
export default {
  props: ['hidden'],
  mixins: [nhfMixins],
  data() {
    return {
      title: <span>调整动物类型/配方模型<span class='titleTips'>部分动物类型和配方模型即将下线请及时调整</span></span>,
      form: this.$form.createForm(this),
      animal: [],
      modelCache: []
    }
  },
  mounted(){
    this.initAnimal()
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    animalChange(val,select){
      if(select){
        let {name: animalTypeName,id: animalTypeCode} = [...select].pop() || {}
        let {id: animalRootId} =[...select].shift()
        this.getLine(animalTypeCode)
        this.form.setFieldsValue({animalTypeName,animalTypeCode,animalRootId,modelId: undefined})
      }else{
        this.form.setFieldsValue({animalTypeName: undefined,animalTypeCode: undefined,animalRootId: undefined,modelId: undefined})
        this.model.records = []
      }
    },
    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },
    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId,factoryId})
      targetOption.loading = false
      res.data = res.data.filter(el => !this.deleteIds.includes(el.id))
      targetOption.children = res.data.map(this.mapFilter)
      this.animal = [...this.animal]
    },
    async initAnimal(){
      let factoryId = window.localStorage.getItem('factoryId')
      const res = await this.animalTypeList({parentId:0,factoryId})
      const {data} = res || {}
      if(data && data.length && data[0].id){
        const resAnimal = await this.animalTypeList({parentId:data[0].id,factoryId})
        this.animal = resAnimal.data.map(this.mapFilter)
      } else{
        this.animal = res.data.map(this.mapFilter)
      }
    },
    ok(){
      this.form.validateFields( async (valid,values) => {
        if (!valid) {
          let data = {
            ...this.detail,
            ...values
          }
          await this.fetchPost({
            actions: this.formulaManageUpdate,
            data,
          });
          this.$emit('close',true)
        } else {
          return false
        }
      })
    },
    cancel(){
      this.$emit('close')
    },
    async getLine(animalId){
      if(!animalId) return
      let res = await this.fetchGet({
        actions:this.selectLineAnimalByAnimalId,
        data:{
          animalId
        },
      })
      let {success,data} = res || {}
      if(success) {
        let {lineId:animalTypeId} = data || {}
        this.getModelList({animalTypeId})
      }
    },
    async getModelList(arg={}){
      await this.fetchGet({
        actions:this.formulaModel,
        data:{
          size:300,
          current:1,
          ...arg
        },
        name:'model'
      })
      if(this.model.records.length === 0) {
        this.model.records = []
      } else {
        this.model.records = this.model.records.filter(el => !this.modelIds.includes(el.id))
        this.modelCache = JSON.parse(JSON.stringify(this.model.records))
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .titleTips{
    color: gray;
    font-size: 12px;
    margin-left: 5px;
  }
</style>